<template>
    <div>
        <icon-circled
            v-if="icon"
            :size="110"
            :icon="icon"
            :class="$css($theme.textPrimary)"
            class="d-block mx-auto mb-4"
        />

        <p
            v-if="title"
            class="font--20 lh--26 font-weight-light text-center mb-8"
            :class="$css($theme.textPrimary)"
        >
            {{ ucfirst(title) }}
        </p>

        <p
            v-if="description"
            class="font--14 text-dark text-center mb-0 text--ucfirst"
            v-html="description"
        />
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import IconCircled from "~/components/elements/IconCircled"

export default {
    props: {
        title: String,
        description: String,
        icon: {
            type: String,
            default: "info",
        },
    },

    methods: {
        ucfirst,
    },

    components: {
        IconCircled,
    },
}
</script>
